import * as React from 'react'
import { useCallback, useState } from 'react'

import { EditAdditionalInfoDrawer } from '@user/components/DetailPages/sections/AdditionalInformation/Edit/EditDrawer'
import { ENTITY_TYPES } from '@sales-center/common'

import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

interface Props {
  entityId: number
  entityType: ENTITY_TYPES
  dataTestId?: string
}

export function EditButton(props: Props) {
  const { entityId, entityType, dataTestId } = props

  const [editDrawerOpen, setEditDrawerOpen] = useState<boolean>(false)

  const openEditDrawer = useCallback(() => {
    setEditDrawerOpen(true)
  }, [])

  const closeEditDrawer = useCallback(() => {
    setEditDrawerOpen(false)
  }, [])

  return (
    <>
      <Button
        onClick={openEditDrawer}
        color="primary"
        variant="outlined"
        data-test-id={dataTestId ? dataTestId : ''}
      >
        <Typography
          color="#19305A"
          fontSize="13px"
          fontFamily="Source Sans Pro Semibold"
        >
          Edit
        </Typography>
      </Button>

      <EditAdditionalInfoDrawer
        entityId={entityId}
        entityType={entityType}
        onClose={closeEditDrawer}
        open={editDrawerOpen}
      />
    </>
  )
}
